import React, { ReactNode} from 'react'
import { Box, Card, CardContent, Grid, Typography } from '@material-ui/core'

import { Place } from '../../api/models'

interface PlaceCardProps {
  item: Place
  children?: ReactNode
}

export const PlaceCard = (props: PlaceCardProps) => {
  const { item } = props
  const Icon = item?.icon
  return (
    <Card>
      <CardContent>
        <Typography>
          <Icon /> {item.typeDisplay}
        </Typography>
        <Grid container spacing={10}>
          <Grid item container>
            <Grid item container spacing={6} xs={12}>
              <Grid item>
                <Box fontWeight="bold">SquID:</Box>
              </Grid>
              <Grid item>{item.guid}</Grid>
            </Grid>
            <Grid item container spacing={6} xs={12}>
              <Grid item>
                <Box fontWeight="bold">Path:</Box>
              </Grid>
              <Grid item>{item.path}</Grid>
            </Grid>
            <Grid item container spacing={6} xs={12}>
              <Grid item>
                <Box fontWeight="bold">Short:</Box>
              </Grid>
              <Grid item>{item.shortPath}</Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
